import React from 'react';
import { observer } from 'mobx-react';
import { Descope, UserProfile as DescopeUserProfile, useUser } from '@descope/react-sdk';

import { UserProfileHeader } from './components/header';
import { Loader } from 'common/components/branch-plus-policy/loader';
import useSession from 'core/hooks/use-session';
import { signOut } from '../auth';
import useStyles from './user-profile.styles';

// @TODO: Remove this once Descope supports CSP nonce for user profile widget
const nonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content');
window.DESCOPE_NONCE = nonce;

const UserProfile = () => {
  const classes = useStyles();
  const { user, isUserLoading } = useUser();
  const { loading: isSessionLoading, isImpersonating } = useSession();

  const isLoading = isUserLoading || isSessionLoading;

  return (
    <>
      <UserProfileHeader />
      {isLoading ? (
        <Loader />
      ) : (
        <div className={classes.descopeWidgets}>
          <DescopeUserProfile
            widgetId="user-profile-widget"
            tenant={user?.userTenants?.[0]?.tenantId}
            onLogout={async () => {
              await signOut();
            }}
          />
          {!isImpersonating && <Descope flowId="collect-impersonation-consent" nonce={nonce} />}
        </div>
      )}
      <div className={classes.footerWrapper} />
    </>
  );
};

export default observer(UserProfile);
